import { type Localization } from '../Hooks/useLocalization'
import {
  type CertificateStatusesExpired,
  type Certificate,
  type CertificateStatus,
  type CompanyBranch,
  certificateStatusesExpired,
} from '../Store/DataSlice'

export function formatCompanyBranch(
  branch: CompanyBranch,
  countryLocalization: Localization
) {
  let formatted = `${branch.number} `
  if (branch.addressLine1) formatted += `${branch.addressLine1}, `
  if (branch.postalCode || branch.city)
    formatted += `${branch.postalCode} ${branch.city}, `
  if (branch.countryCode)
    formatted += countryLocalization.text(
      branch.countryCode,
      branch.countryCode
    )
  return formatted
}

export function calculateCertificateActualStatus(
  certificate: Certificate | undefined
): CertificateStatus | CertificateStatusesExpired | '' {
  if (certificate === undefined) return ''
  if (certificate.status !== 'Valid' && certificate.status !== 'Prolonged')
    return certificate.status
  if (
    certificate.validFrom <= Date.now() &&
    (certificate.status === 'Prolonged' &&
    certificate.extendedUntil !== undefined
      ? certificate.extendedUntil
      : certificate.validUntil) >= Date.now()
  )
    return certificate.status
  return certificateStatusesExpired
}
